import { useEffect, useState } from 'react';

/**
 * The value as it was `delayMs` ago, settling only once it stops changing —
 * so a typed search term reaches the server once per pause, not once per
 * keystroke. (Prod 2026-10-19: fourteen keystrokes in the Lite site search
 * became fourteen concurrent sites queries of ~55 s each.)
 */
export function useDebouncedValue<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
